import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';

interface ResultSceneData {
  score: number;
}

export default class ResultScene extends Phaser.Scene {
  private score: number = 0;
  private scoreText?: Phaser.GameObjects.Text;
  private gameoverSound?: Phaser.Sound.BaseSound;

  constructor() {
    super({ key: 'ResultScene' });
  }

  init(data: ResultSceneData): void {
    this.score = data.score || 0;
  }

  create(): void {
    const { width, height } = this.scale;
    
    // 背景色を設定
    this.cameras.main.setBackgroundColor(0x72aabf);
    
    // BGMを確実に停止（念のため）
    const bgm = this.sound.get('bgm');
    if (bgm && bgm.isPlaying) {
      bgm.stop();
    }
    
    // ゲームオーバー音は既にPlaySceneのgameOver()で再生されているので、取得するだけ
    const existingGameoverSound = this.sound.get('gameover');
    if (existingGameoverSound && existingGameoverSound.isPlaying) {
      this.gameoverSound = existingGameoverSound;
    }
    
    // リザルトテキスト
    const resultText = this.add.text(width / 2, height / 2 - 150, 'GAME OVER', {
      fontSize: '64px',
      fontFamily: 'Tiny5',
      color: `#${GAME_CONFIG.colors.text.toString(16).padStart(6, '0')}`,
      fontStyle: 'bold',
    });
    resultText.setOrigin(0.5);
    resultText.setDepth(100);
    
    // スコア表示
    this.scoreText = this.add.text(width / 2, height / 2 - 50, `SCORE: ${this.score}`, {
      fontSize: '48px',
      fontFamily: 'Tiny5',
      color: `#${GAME_CONFIG.colors.text.toString(16).padStart(6, '0')}`,
    });
    this.scoreText.setOrigin(0.5);
    this.scoreText.setDepth(100);
    
    // ボタンを作成
    this.createButtons();
  }

  private createButtons(): void {
    const { width, height } = this.scale;
    
    // ホームボタン（中央配置）
    const homeButton = this.add.rectangle(width / 2, height / 2 + 100, 200, 60, 0x666666, 1);
    homeButton.setDepth(100);
    homeButton.setInteractive({ useHandCursor: true });
    homeButton.on('pointerdown', () => {
      // クリック時に色を変更
      homeButton.setFillStyle(0x555555, 1);
    });
    homeButton.on('pointerup', () => {
      // 離した時に色を元に戻し、ボタンの動作を実行
      homeButton.setFillStyle(0x666666, 1);
      // ボタン効果音を再生
      const buttonSound = this.sound.add('button', { volume: 0.5 });
      buttonSound.play();
      // ゲームオーバー音を停止
      this.stopGameoverSound();
      this.scene.start('TitleScene');
    });
    homeButton.on('pointerout', () => {
      // ボタン外に出た時に色を元に戻す
      homeButton.setFillStyle(0x666666, 1);
    });
    homeButton.on('pointercancel', () => {
      // タッチがキャンセルされた時（スワイプなど）に色を元に戻す
      homeButton.setFillStyle(0x666666, 1);
    });
    
    const homeText = this.add.text(width / 2, height / 2 + 100, 'HOME', {
      fontSize: '32px',
      fontFamily: 'Tiny5',
      color: '#ffffff',
    });
    homeText.setOrigin(0.5);
    homeText.setDepth(101);
  }

  /**
   * ゲームオーバー音を停止
   */
  private stopGameoverSound(): void {
    // 現在再生中のゲームオーバー音を停止
    if (this.gameoverSound) {
      if (this.gameoverSound.isPlaying) {
        this.gameoverSound.stop();
      }
      // サウンドを破棄
      this.gameoverSound.destroy();
      this.gameoverSound = undefined;
    }
    
    // サウンドマネージャーからも取得して停止（念のため）
    const gameoverSound = this.sound.get('gameover');
    if (gameoverSound) {
      if (gameoverSound.isPlaying) {
        gameoverSound.stop();
      }
      gameoverSound.destroy();
    }
    
    // 全てのゲームオーバー音を停止（念のため）
    const allSounds = this.sound.getAllPlaying();
    allSounds.forEach(sound => {
      if (sound.key === 'gameover') {
        sound.stop();
        sound.destroy();
      }
    });
  }
}

